import {twx} from '@/utils/tailwindUtils';

type DynamicPageSectionProps = {
    children: React.ReactNode;
    className?: string;
    id?: string;
};

/**
 * Wrapper for an AEM dynamic-page section.
 * Provides a stable `<section id>` boundary; children that return `null`
 * collapse naturally to an empty section.
 */
const DynamicPageSection = ({children, className, id}: DynamicPageSectionProps) => (
    <section id={id} className={twx(className)}>
        {children}
    </section>
);

export default DynamicPageSection;
